const caretColor = {
  name: "caret-color",
  path: "/caret-color",
  title: "caret-color",
  description: "Utilities for controlling the color of the text input cursor.",
  value: {
  "color": {
    "caret-color-inherit": "inherit",
    "caret-color-current": "currentColor",
    "caret-color-transparent": "transparent",
    "caret-color-[value]": "[value]",
    "caret-color-black": "var(--color-black)",
    "caret-color-white": "var(--color-white)",
    "caret-color-red-50": "var(--color-red-50)",
    "caret-color-red-100": "var(--color-red-100)",
    "caret-color-red-200": "var(--color-red-200)",
    "caret-color-red-300": "var(--color-red-300)",
    "caret-color-red-400": "var(--color-red-400)",
    "caret-color-red-500": "var(--color-red-500)",
    "caret-color-red-600": "var(--color-red-600)",
    "caret-color-red-700": "var(--color-red-700)",
    "caret-color-red-800": "var(--color-red-800)",
    "caret-color-red-900": "var(--color-red-900)",
    "caret-color-orange-50": "var(--color-orange-50)",
    "caret-color-orange-100": "var(--color-orange-100)",
    "caret-color-orange-200": "var(--color-orange-200)",
    "caret-color-orange-300": "var(--color-orange-300)",
    "caret-color-orange-400": "var(--color-orange-400)",
    "caret-color-orange-500": "var(--color-orange-500)",
    "caret-color-orange-600": "var(--color-orange-600)",
    "caret-color-orange-700": "var(--color-orange-700)",
    "caret-color-orange-800": "var(--color-orange-800)",
    "caret-color-orange-900": "var(--color-orange-900)",
    "caret-color-amber-50": "var(--color-amber-50)",
    "caret-color-amber-100": "var(--color-amber-100)",
    "caret-color-amber-200": "var(--color-amber-200)",
    "caret-color-amber-300": "var(--color-amber-300)",
    "caret-color-amber-400": "var(--color-amber-400)",
    "caret-color-amber-500": "var(--color-amber-500)",
    "caret-color-amber-600": "var(--color-amber-600)",
    "caret-color-amber-700": "var(--color-amber-700)",
    "caret-color-amber-800": "var(--color-amber-800)",
    "caret-color-amber-900": "var(--color-amber-900)",
    "caret-color-yellow-50": "var(--color-yellow-50)",
    "caret-color-yellow-100": "var(--color-yellow-100)",
    "caret-color-yellow-200": "var(--color-yellow-200)",
    "caret-color-yellow-300": "var(--color-yellow-300)",
    "caret-color-yellow-400": "var(--color-yellow-400)",
    "caret-color-yellow-500": "var(--color-yellow-500)",
    "caret-color-yellow-600": "var(--color-yellow-600)",
    "caret-color-yellow-700": "var(--color-yellow-700)",
    "caret-color-yellow-800": "var(--color-yellow-800)",
    "caret-color-yellow-900": "var(--color-yellow-900)",
    "caret-color-lime-50": "var(--color-lime-50)",
    "caret-color-lime-100": "var(--color-lime-100)",
    "caret-color-lime-200": "var(--color-lime-200)",
    "caret-color-lime-300": "var(--color-lime-300)",
    "caret-color-lime-400": "var(--color-lime-400)",
    "caret-color-lime-500": "var(--color-lime-500)",
    "caret-color-lime-600": "var(--color-lime-600)",
    "caret-color-lime-700": "var(--color-lime-700)",
    "caret-color-lime-800": "var(--color-lime-800)",
    "caret-color-lime-900": "var(--color-lime-900)",
    "caret-color-green-50": "var(--color-green-50)",
    "caret-color-green-100": "var(--color-green-100)",
    "caret-color-green-200": "var(--color-green-200)",
    "caret-color-green-300": "var(--color-green-300)",
    "caret-color-green-400": "var(--color-green-400)",
    "caret-color-green-500": "var(--color-green-500)",
    "caret-color-green-600": "var(--color-green-600)",
    "caret-color-green-700": "var(--color-green-700)",
    "caret-color-green-800": "var(--color-green-800)",
    "caret-color-green-900": "var(--color-green-900)",
    "caret-color-emerald-50": "var(--color-emerald-50)",
    "caret-color-emerald-100": "var(--color-emerald-100)",
    "caret-color-emerald-200": "var(--color-emerald-200)",
    "caret-color-emerald-300": "var(--color-emerald-300)",
    "caret-color-emerald-400": "var(--color-emerald-400)",
    "caret-color-emerald-500": "var(--color-emerald-500)",
    "caret-color-emerald-600": "var(--color-emerald-600)",
    "caret-color-emerald-700": "var(--color-emerald-700)",
    "caret-color-emerald-800": "var(--color-emerald-800)",
    "caret-color-emerald-900": "var(--color-emerald-900)",
    "caret-color-teal-50": "var(--color-teal-50)",
    "caret-color-teal-100": "var(--color-teal-100)",
    "caret-color-teal-200": "var(--color-teal-200)",
    "caret-color-teal-300": "var(--color-teal-300)",
    "caret-color-teal-400": "var(--color-teal-400)",
    "caret-color-teal-500": "var(--color-teal-500)",
    "caret-color-teal-600": "var(--color-teal-600)",
    "caret-color-teal-700": "var(--color-teal-700)",
    "caret-color-teal-800": "var(--color-teal-800)",
    "caret-color-teal-900": "var(--color-teal-900)",
    "caret-color-cyan-50": "var(--color-cyan-50)",
    "caret-color-cyan-100": "var(--color-cyan-100)",
    "caret-color-cyan-200": "var(--color-cyan-200)",
    "caret-color-cyan-300": "var(--color-cyan-300)",
    "caret-color-cyan-400": "var(--color-cyan-400)",
    "caret-color-cyan-500": "var(--color-cyan-500)",
    "caret-color-cyan-600": "var(--color-cyan-600)",
    "caret-color-cyan-700": "var(--color-cyan-700)",
    "caret-color-cyan-800": "var(--color-cyan-800)",
    "caret-color-cyan-900": "var(--color-cyan-900)",
    "caret-color-sky-50": "var(--color-sky-50)",
    "caret-color-sky-100": "var(--color-sky-100)",
    "caret-color-sky-200": "var(--color-sky-200)",
    "caret-color-sky-300": "var(--color-sky-300)",
    "caret-color-sky-400": "var(--color-sky-400)",
    "caret-color-sky-500": "var(--color-sky-500)",
    "caret-color-sky-600": "var(--color-sky-600)",
    "caret-color-sky-700": "var(--color-sky-700)",
    "caret-color-sky-800": "var(--color-sky-800)",
    "caret-color-sky-900": "var(--color-sky-900)",
    "caret-color-blue-50": "var(--color-blue-50)",
    "caret-color-blue-100": "var(--color-blue-100)",
    "caret-color-blue-200": "var(--color-blue-200)",
    "caret-color-blue-300": "var(--color-blue-300)",
    "caret-color-blue-400": "var(--color-blue-400)",
    "caret-color-blue-500": "var(--color-blue-500)",
    "caret-color-blue-600": "var(--color-blue-600)",
    "caret-color-blue-700": "var(--color-blue-700)",
    "caret-color-blue-800": "var(--color-blue-800)",
    "caret-color-blue-900": "var(--color-blue-900)",
    "caret-color-indigo-50": "var(--color-indigo-50)",
    "caret-color-indigo-100": "var(--color-indigo-100)",
    "caret-color-indigo-200": "var(--color-indigo-200)",
    "caret-color-indigo-300": "var(--color-indigo-300)",
    "caret-color-indigo-400": "var(--color-indigo-400)",
    "caret-color-indigo-500": "var(--color-indigo-500)",
    "caret-color-indigo-600": "var(--color-indigo-600)",
    "caret-color-indigo-700": "var(--color-indigo-700)",
    "caret-color-indigo-800": "var(--color-indigo-800)",
    "caret-color-indigo-900": "var(--color-indigo-900)",
    "caret-color-violet-50": "var(--color-violet-50)",
    "caret-color-violet-100": "var(--color-violet-100)",
    "caret-color-violet-200": "var(--color-violet-200)",
    "caret-color-violet-300": "var(--color-violet-300)",
    "caret-color-violet-400": "var(--color-violet-400)",
    "caret-color-violet-500": "var(--color-violet-500)",
    "caret-color-violet-600": "var(--color-violet-600)",
    "caret-color-violet-700": "var(--color-violet-700)",
    "caret-color-violet-800": "var(--color-violet-800)",
    "caret-color-violet-900": "var(--color-violet-900)",
    "caret-color-purple-50": "var(--color-purple-50)",
    "caret-color-purple-100": "var(--color-purple-100)",
    "caret-color-purple-200": "var(--color-purple-200)",
    "caret-color-purple-300": "var(--color-purple-300)",
    "caret-color-purple-400": "var(--color-purple-400)",
    "caret-color-purple-500": "var(--color-purple-500)",
    "caret-color-purple-600": "var(--color-purple-600)",
    "caret-color-purple-700": "var(--color-purple-700)",
    "caret-color-purple-800": "var(--color-purple-800)",
    "caret-color-purple-900": "var(--color-purple-900)",
    "caret-color-fuchsia-50": "var(--color-fuchsia-50)",
    "caret-color-fuchsia-100": "var(--color-fuchsia-100)",
    "caret-color-fuchsia-200": "var(--color-fuchsia-200)",
    "caret-color-fuchsia-300": "var(--color-fuchsia-300)",
    "caret-color-fuchsia-400": "var(--color-fuchsia-400)",
    "caret-color-fuchsia-500": "var(--color-fuchsia-500)",
    "caret-color-fuchsia-600": "var(--color-fuchsia-600)",
    "caret-color-fuchsia-700": "var(--color-fuchsia-700)",
    "caret-color-fuchsia-800": "var(--color-fuchsia-800)",
    "caret-color-fuchsia-900": "var(--color-fuchsia-900)",
    "caret-color-pink-50": "var(--color-pink-50)",
    "caret-color-pink-100": "var(--color-pink-100)",
    "caret-color-pink-200": "var(--color-pink-200)",
    "caret-color-pink-300": "var(--color-pink-300)",
    "caret-color-pink-400": "var(--color-pink-400)",
    "caret-color-pink-500": "var(--color-pink-500)",
    "caret-color-pink-600": "var(--color-pink-600)",
    "caret-color-pink-700": "var(--color-pink-700)",
    "caret-color-pink-800": "var(--color-pink-800)",
    "caret-color-pink-900": "var(--color-pink-900)",
    "caret-color-rose-50": "var(--color-rose-50)",
    "caret-color-rose-100": "var(--color-rose-100)",
    "caret-color-rose-200": "var(--color-rose-200)",
    "caret-color-rose-300": "var(--color-rose-300)",
    "caret-color-rose-400": "var(--color-rose-400)",
    "caret-color-rose-500": "var(--color-rose-500)",
    "caret-color-rose-600": "var(--color-rose-600)",
    "caret-color-rose-700": "var(--color-rose-700)",
    "caret-color-rose-800": "var(--color-rose-800)",
    "caret-color-rose-900": "var(--color-rose-900)",
    "caret-color-slate-50": "var(--color-slate-50)",
    "caret-color-slate-100": "var(--color-slate-100)",
    "caret-color-slate-200": "var(--color-slate-200)",
    "caret-color-slate-300": "var(--color-slate-300)",
    "caret-color-slate-400": "var(--color-slate-400)",
    "caret-color-slate-500": "var(--color-slate-500)",
    "caret-color-slate-600": "var(--color-slate-600)",
    "caret-color-slate-700": "var(--color-slate-700)",
    "caret-color-slate-800": "var(--color-slate-800)",
    "caret-color-slate-900": "var(--color-slate-900)",
    "caret-color-gray-50": "var(--color-gray-50)",
    "caret-color-gray-100": "var(--color-gray-100)",
    "caret-color-gray-200": "var(--color-gray-200)",
    "caret-color-gray-300": "var(--color-gray-300)",
    "caret-color-gray-400": "var(--color-gray-400)",
    "caret-color-gray-500": "var(--color-gray-500)",
    "caret-color-gray-600": "var(--color-gray-600)",
    "caret-color-gray-700": "var(--color-gray-700)",
    "caret-color-gray-800": "var(--color-gray-800)",
    "caret-color-gray-900": "var(--color-gray-900)",
    "caret-color-zinc-50": "var(--color-zinc-50)",
    "caret-color-zinc-100": "var(--color-zinc-100)",
    "caret-color-zinc-200": "var(--color-zinc-200)",
    "caret-color-zinc-300": "var(--color-zinc-300)",
    "caret-color-zinc-400": "var(--color-zinc-400)",
    "caret-color-zinc-500": "var(--color-zinc-500)",
    "caret-color-zinc-600": "var(--color-zinc-600)",
    "caret-color-zinc-700": "var(--color-zinc-700)",
    "caret-color-zinc-800": "var(--color-zinc-800)",
    "caret-color-zinc-900": "var(--color-zinc-900)",
    "caret-color-neutral-50": "var(--color-neutral-50)",
    "caret-color-neutral-100": "var(--color-neutral-100)",
    "caret-color-neutral-200": "var(--color-neutral-200)",
    "caret-color-neutral-300": "var(--color-neutral-300)",
    "caret-color-neutral-400": "var(--color-neutral-400)",
    "caret-color-neutral-500": "var(--color-neutral-500)",
    "caret-color-neutral-600": "var(--color-neutral-600)",
    "caret-color-neutral-700": "var(--color-neutral-700)",
    "caret-color-neutral-800": "var(--color-neutral-800)",
    "caret-color-neutral-900": "var(--color-neutral-900)",
    "caret-color-stone-50": "var(--color-stone-50)",
    "caret-color-stone-100": "var(--color-stone-100)",
    "caret-color-stone-200": "var(--color-stone-200)",
    "caret-color-stone-300": "var(--color-stone-300)",
    "caret-color-stone-400": "var(--color-stone-400)",
    "caret-color-stone-500": "var(--color-stone-500)",
    "caret-color-stone-600": "var(--color-stone-600)",
    "caret-color-stone-700": "var(--color-stone-700)",
    "caret-color-stone-800": "var(--color-stone-800)",
    "caret-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `<textarea class="caret-pink-500 ..."></textarea>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="caret-color-gray-600 text-sm dark:caret-color-gray-300 mb-10">
        Use <code class="caret-color-gray-800 dark:caret-color-white font-semibold">caret-color-rose-500</code> utilities to change the accent color of an element.
      </p>
      <div class="flex justify-center">
        <textarea class="w-80 rounded-md p-2 text-sm caret-color-rose-500 ring-1 ring-color-gray-900/10 focus:ring-2 focus:ring-color-pink-500 focus:outline-none dark:bg-color-gray-950/25 dark:ring-1 dark:ring-color-white/5 dark:focus:bg-color-gray-950/10 dark:focus:ring-2 dark:focus:ring-color-pink-500" rows="2" spellcheck="false"></textarea>
      </div>
    `
  }
]
}
export default caretColor;

<div class="sr-only">
<div class="flex justify-center">
        <textarea class="w-80 rounded-md p-2 text-sm caret-color-rose-500 ring-1 ring-color-gray-900/10 focus:ring-2 focus:ring-color-pink-500 focus:outline-none dark:bg-color-gray-950/25 dark:ring-1 dark:ring-color-white/5 dark:focus:bg-color-gray-950/10 dark:focus:ring-2 dark:focus:ring-color-pink-500" rows="2" spellcheck="false"></textarea>
      </div>
</div>